import { useSearchParams } from "react-router-dom"

import type { OnboardingStep as PageBuilderOnboardingStep } from "../Onboarding/Onboarding"

export function useSharedOnboardingParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  function setStepParam(step: PageBuilderOnboardingStep) {
    searchParams.set("onboardingStep", step)
    setSearchParams(searchParams)
  }

  function deleteStepParam() {
    if (searchParams.get("onboardingStep")) {
      searchParams.delete("onboardingStep")
      setSearchParams(searchParams)
    }
  }

  return {
    searchParams,
    onboardingStep: searchParams.get("onboardingStep"),
    setStepParam,
    deleteStepParam
  }
}
